<template>
  <div class="quotes">
    <v-card class="px-2 cursor-pointer">
      <v-row align-md="center">
        <v-col cols="12" md="8" lg="9">
          <div class="d-flex align-center">
            <div>
              <v-img
                width="80"
                height="60"
                src="https://picsum.photos/id/11/100/60"
              ></v-img>
            </div>
            <div class="ml-1">
              <h6 class="primary--text pb-0 mb-0">
                <strong>{{ rfq.project.contractor_name }}</strong>
              </h6>
              <div>
                <strong>Phone: </strong>
                <span>{{ rfq.project.phone }} </span>
              </div>
              <div>
                <strong>Address: </strong>
                <span v-if="rfq.project.address.address_line_1"
                  >{{ rfq.project.address.address_line_1 }}
                </span>
                <span v-if="rfq.project.address.address_line_2"
                  >, {{ rfq.project.address.address_line_2 }}
                </span>
                <span v-if="rfq.project.address.address_line_3"
                  >, {{ rfq.project.address.address_line_3 }}
                </span>
              </div>
            </div>
          </div>
        </v-col>
        <v-col cols="12" md="4" lg="3" class="text-right text-md-left">
          <div>
            <strong>Status: </strong>
            <span class="text-capitalize">{{ rfq.status }}</span>
          </div>
          <v-btn
            v-if="rfq.status !== 'lost' && rfq.status !== 'awarded'"
            depressed
            color="primary"
            class="white--text"
            @click="quoteModal = true"
            ><v-icon color="white" size="18" class="mr-1">mdi-send</v-icon> Send
            New Quote</v-btn
          >
        </v-col>
      </v-row>
    </v-card>

    <SendQuote
      v-if="quoteModal && rfq"
      :dialog="quoteModal"
      @close="quoteModal = false"
      @refresh="refreshRFQ"
    />
  </div>
</template>

<script>
import SendQuote from "@/components/rfq/dealer/SendQuote";
export default {
  components: {
    SendQuote
  },
  props: {
    rfq: {
      type: Object,
      default: null
    }
  },
  methods: {
    refreshRFQ() {
      this.$emit("refresh");
    }
  },
  data() {
    return {
      quoteModal: false,
      dealers: [
        {
          id: 1,
          name: "ABC Dealer",
          phone: "801-555-1001",
          address: "3432 Street, Park City Utah 84098",
          status: "not_sent"
        }
      ]
    };
  }
};
</script>
